(function(ns) {
	"use strict";

	ns.validator = {
		notEmpty: function(value) {
			if (value == null) return false;
			return String(value).trim() !== "";
		},
		notEmptyBy: function(by_value, value) {
			if (by_value === true && value == null) return false;
			return String(value).trim() !== "";
		},
		maxLength: function(length, value) {
			if (value == null) return true;
			return String(value).length <= length;
		},
		minLength: function(length, value) {
			if (value == null) return true;
			if (value === "") return true;
			return String(value).length >= length;
		},
		url: function(value) {
			if (value == null) return true;
			return /^https?:\/{2}/.test(String(value));
		},
		email: function(value) {
			if (value == null) return true;
			if (String(value).length > 253) return false;
			return /^[a-zA-Z0-9!#$%&\'*+\-\/\=?^_`{|}~]+(?:[.][a-zA-Z0-9!#$%&\'*+\-\/\=?^_`{|}~]+)*[@](?:[a-zA-Z0-9](?:[-a-zA-Z0-9]*[a-zA-Z0-9])[.])*[a-zA-Z](?:[-a-zA-Z0-9]*[a-zA-Z0-9])?[.]?/.test(value);
		},
		hiragana: function(value) {
			if (value == null) return true;
			return !/[^ \u3041-\u3096\u3099\u309a\u309d-\u309e\u30fc]/.test(String(value));
		},
		katakana: function(value) {
			if (value == null) return true;
			return !/[^ \u3099\u309a\u30a1-\u30fa\u30fc-\u30fe]/.test(String(value));
		},
		kana: function(value) {
			if (value == null) return true;
			var nValue = normSp(String(value));
			// \u30FB は中黒「・」
			if (/[^ \u3041-\u3096\u3099\u309a\u309d-\u309e\u30a1-\u30fa\u30fb\u30fc-\u30fe]/.test(nValue)) return false;
			return nValue;
		},
		phoneJPFormat: function(value) {
			if (value == null) return true;
			var nValue = zen2han(String(value));
			nValue = nValue.replace(/[()]/g, "-");
			nValue = nValue.replace(/^-|-$/g, "");
			nValue = nValue.replace(/-+/g, "-");
// 			if (nValue.length > 16) return false;
// 			if (!/^(\d+-)*\d+$/.test(nValue)) return false;
			nValue = nValue.replace(/-/g, "");
			if (/[^\d]/.test(nValue)) return false;
			return nValue;
		},
		phoneJPLength: function(value) {
			if (value == null) return true;
			var nValue = zen2han(String(value));
			nValue = nValue.replace(/[()]/g, "-");
			nValue = nValue.replace(/^-|-$/g, "");
			nValue = nValue.replace(/-+/g, "-");
			nValue = nValue.replace(/-/g, "");
			if (nValue.length < 10 || 11 < nValue.length) return false;
			return nValue;
		},
		postalJP: function(value) {
			if (value == null) return true;
			var nValue = zen2han(String(value));
			var found = nValue.match(/^(\d{3})-?(\d{4})$/);
			if (!found) return false;
			return found[1] + "-" + found[2];
		},
		password: function(value) {
			if (value == null) return true;
			return !/[^ -~]/.test(String(value)); // ASCII文字のみ
		},
		array_some: function(value) {
			if (value == null) return true;
			return value.length >= 1;
		},
		radio_checked: function(value) {
			if (value == null) return false;
			return String(value).trim() !== "";
		},
		latitude: function(value) {
			if (value == null) return false;
			var f = parseFloat(value);
			return !isNaN(f) && -90 <= f && f <= 90;
		},
		longitude: function(value) {
			if (value == null) return false;
			var f = parseFloat(value);
			return !isNaN(f) && -180 <= f && f <= 180;
		},
	};

	// 空白文字を正規化
	function normSp(value) {
		return value.replace(/[\u200B\u200C\u200D\uFEFF\u2028\u2029\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000]/g, " ");
	}

	// 全角英数→半角英数
	function zen2han(value) {
		return normSp(value)
		.replace(/[\u2212\uff0d\u30fc\u2012\u2013\u2014\u2015\u2500]/g, "-") // ハイフンと似た文字
		.replace(/[\uFF01-\uFF5E]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
		});
	}

})(CE);
